import colors from '../../colors';
export const mappingColor = {
  red: colors.C_SECONDARY_RED_3,
  tosca: colors.C_SECONDARY_TOSCA_4,
  yellow: colors.C_TERTIARY_YELLOW_3,
  white: colors.C_WHITE_100,
  white10: colors.generateRGBA('white', 0.1),
  white20: colors.generateRGBA('white', 0.2),
  white30: colors.generateRGBA('white', 0.3),
  white40: colors.generateRGBA('white', 0.4),
  white50: colors.generateRGBA('white', 0.5),
  white60: colors.generateRGBA('white', 0.6),
  white70: colors.generateRGBA('white', 0.7),
  white80: colors.generateRGBA('white', 0.8),
  white90: colors.generateRGBA('white', 0.9),
  black: colors.C_BLACK_100,
  black5: colors.C_BLACK_5,
  black10: colors.C_BLACK_10,
  black15: colors.C_BLACK_15,
  black20: colors.C_BLACK_20,
  black25: colors.C_BLACK_25,
  black30: colors.C_BLACK_30,
  black35: colors.C_BLACK_35,
  black40: colors.C_BLACK_40,
  black45: colors.C_BLACK_45,
  black50: colors.C_BLACK_50,
  black55: colors.C_BLACK_55,
  black60: colors.C_BLACK_60,
  black65: colors.C_BLACK_65,
  black70: colors.C_BLACK_70,
  black75: colors.C_BLACK_75,
  black80: colors.C_BLACK_80,
  black85: colors.C_BLACK_85,
  black90: colors.C_BLACK_90,
  black95: colors.C_BLACK_95
};
export const getIconStyle = theme => ({
  fill: mappingColor[theme]
});